import { get, post } from 'utils/methods';

export function getRollsOutApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_PP}rolls-outs`, data, headers);
}

export function createRollOutApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_PP}commands/rolls-out`, data, headers);
}

export function toggleRollOutStatusApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_PP}commands/rolls-out/status`, data, headers);
}
